export default [
  // {
  //   name: "Disciplinary Cases",
  //   icon: "group",
  //   to: "/disciplinary/raised",
  //   enabled: false,
  // },
  {
    name: "My Accused Disciplinary Cases",
    icon: "switch_account",
    to: "/disciplinary/accused",
    enabled: true,
  },
];
